import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

export interface IdeLocation {
  repoId: number;
  dashId: number;
  repoFileName: string;
  folderPath: string;
}

export interface IdeState {
  lastLocation: IdeLocation | null;
  history: IdeLocation[];
}

export interface IdePersistedState {
  lastLocation: IdeLocation | null;
  history: IdeLocation[];
}

const initialState: IdeState = {
  lastLocation: null,
  history: [],
};

export const ideSlice = createSlice({
  name: "ide",
  initialState,
  reducers: {
    setIdeLocation: (state, action: PayloadAction<IdeLocation>) => {
      state.lastLocation = action.payload;
      // Update history: keep most recent first, max 50
      // Remove existing identical entry if present
      state.history = state.history.filter(
        (loc) =>
          !(
            loc.repoId === action.payload.repoId &&
            loc.dashId === action.payload.dashId &&
            loc.repoFileName === action.payload.repoFileName
          )
      );
      state.history.unshift(action.payload);
      if (state.history.length > 50) {
        state.history = state.history.slice(0, 50);
    }
  },
    clearIdeLocation: (state) => {
      state.lastLocation = null;
      state.history = [];
    },
    setIdeState: (state, action: PayloadAction<IdePersistedState>) => {
      state.lastLocation = action.payload.lastLocation;
      state.history = action.payload.history || [];
    },
  },
});

export const { setIdeLocation, clearIdeLocation, setIdeState } = ideSlice.actions;

export const selectIde = (state: RootState) => state.ide;
export const selectLastIdeLocation = (state: RootState) => state.ide.lastLocation;
export const selectIdeHistory = (state: RootState) => state.ide.history;

export default ideSlice.reducer;

